import React, { useState, useRef, useEffect, useMemo } from "react";
import ReactImageFallback from "react-image-fallback";
import { useIntersection } from "../../utils/IntersectionObserver";
import iconSpinner from "../../static/images/iconSpinner.jpg";

const BrandificationImageFallback = ({
  onClick = () => {},
  id = "",
  style = {},
  src,
  fallbackImage,
  className,
  ...props
}) => {
  const [isInView, setIsInView] = useState(false);
  const imgRef = useRef();
  useEffect(() => {
    const url = new URL(window.location.href);
    if (url.searchParams.get("isPDF") === "true") {
      setIsInView(true);
    }
  }, []);

  useIntersection(imgRef, () => {
    setIsInView(true);
  });

  const memoizedFallbackImage = useMemo(() => fallbackImage || "", [fallbackImage]);

  const memoizedSrc = useMemo(() => src || "", [src]);

  const shouldShowImage = useMemo(() => Boolean(isInView && memoizedFallbackImage), [isInView, memoizedFallbackImage]);

  return (
    <div ref={imgRef}>
      <ReactImageFallback
        onClick={onClick}
        src={shouldShowImage ? memoizedSrc : iconSpinner}
        fallbackImage={shouldShowImage ? memoizedFallbackImage : ""}
        initialImage={iconSpinner}
        alt=""
        className={className}
        id={id}
        style={style}
        {...props}
      />
    </div>
  );
};

function fallbackPropsAreEqual(prev, next) {
  return prev.src === next.src && prev.fallbackImage === next.fallbackImage && prev.id === next.id;
}
export default React.memo(BrandificationImageFallback, fallbackPropsAreEqual);
